'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var Config;
(function (Config) {
    Config.OVER_PC_WIDTH = 1200;
    Config.OVER_SP_WIDTH = 600;
    Config.HEADER_HEIGHT = 150;
    //    export const ENV = "production";
})(Config || (Config = {}));
exports.default = Config;
